export const spinningKeyframe = {
  from: {
    transform: 'rotate(360deg)'
  },
  to: {
    transform: 'rotate(0deg)'
  }
};
